import { Avatar, Box, Button, FlexProps, Text } from "@chakra-ui/react";
import React from "react";
import { HiCheck, HiOutlineX } from "react-icons/hi";

export interface INavigation {
  children?: any;
  data?: any;
  declineInvite: () => void;
  acceptInvite: () => void;
  isAccepting: boolean;
  isDeclining: boolean;
}

const NotificationComp: React.FC<INavigation & FlexProps> = ({ children, data, declineInvite, acceptInvite, isAccepting, isDeclining }) => (
  <Box
    borderRadius="8px"
    display="flex"
    _hover={{ bg: "gray.50" }}
    width="100%"
    p={4}
    mb={3}
    transition="all .3s ease-in-out"
    flexDir={{ base: "column", md: "row" }}>
    <Avatar mr={3} d={{ base: "none", sm: "flex" }} width="40px" height="40px" name={data.class_name} borderRadius="8px" />
    {/* <Box width="100%" px={3}> */}
    <Text color="gray.500" fontWeight="600" my="auto" mr="auto">
      You've been invited to&nbsp;
      <Text as="span" color="primary.900">
        {data.class_name}
      </Text>
    </Text>

    <Box d="flex" mt={{ base: 3, md: 0 }}>
      <Button
        borderRadius="full"
        minH="52px"
        minW="52px"
        p={2}
        my="auto"
        colorScheme="blue"
        variant="solid"
        onClick={acceptInvite}
        // isLoading={isAccepting} // FIXME: All buttons are affected while loading
        isDisabled={isAccepting}>
        <Text fontSize="2xl">
          <HiCheck />
        </Text>
      </Button>

      {/* <CloseButton mt={10} borderRadius="full" /> */}

      <Button
        borderRadius="full"
        ml={2}
        minH="52px"
        minW="52px"
        p={2}
        my="auto"
        colorScheme="blue"
        variant="ghost"
        onClick={declineInvite}
        // isLoading={isDeclining} // FIXME: All buttons are affected while loading
        isDisabled={isDeclining}>
        <Text fontSize="2xl">
          <HiOutlineX />
        </Text>
      </Button>
    </Box>
    {/* </Box> */}
  </Box>
);

export default NotificationComp;
